export default {
	label: 'Jira',
	export: 'Eksport',
	sync: 'Värskenda',
	import: 'Import',
	exportCompleted: 'Eksport lõpetatud.',
	importCompleted: 'Importimine on lõpetatud.',
	actionProgress: 'Jira tegevus on pooleli. Palun oodake!',
	importProgress: 'Jira ülesannete importimine on pooleli. Palun oodake!',
	issuesToImport: 'Asutusel {instance} on importida {count} Jira ülesannet veel.',
	standardUpgradeIssues: 'Asutusel {instance} uuendatakse {count} Jira ülesannet seoses standardi uuendusega.',
	exportingIssues: 'Meetmeid eksporditakse Jirasse, palun oodake.',
	isAnotherError: 'Jira ülesannete loomisel on tekkinud viga, palun vaadake põhjuse jaoks logisid.',
	deleteCompleted: 'Jira ülesannete kustutamine on lõpetatud.',
	deleteInProgress: 'Jira ülesannete kustutamine on pooleli.',
	confirmIssueDelete: 'Kas olete kindel, et soovite kustutada Jira ülesanded?',
	status: {
		label: 'Staatus',
		isInitialized: 'Initsialiseeritud',
		notInitialized: 'Mitte initsialiseeritud',
		adminRightsMissing: 'Administraatori õigused puuduvad',
		noDomainConfig: 'Domeeni konfiguratsioon puudub',
		informationMissing: 'Andmed puudulikud',
		taskUnsuccessful: 'Tekkis viga',
	},
	admin: 'Haldur',
	domain: 'Domeen',
	jiraInterface: 'Jira liidestus',
	addNewDomain: 'Lisa uus domeen',
	fieldIsRequired: 'Väli on kohustuslik!',
	invalidField: 'Vigane väli!',
	invalidEmail: 'E-posti address on vigane või puudu!',
	invalidDomain: 'Domeen on vigane või puudu!',
	domainAdded: 'Domeen edukalt lisatud!',
	domainsEdited: 'Domeenid edukalt muudetud!',
	domainDeleted: 'Domeen edukalt kustutatud!',
	email: 'Email',
	apiToken: 'API token',
	limitExceededExport: 'Eksportida saab {count} meetme kaupa',
	limitExceededDelete: 'Kustutada saab {count} meetme kaupa',
	goToSettings: 'Suundu sätete lehele',
	editDomain: 'Muuda domeene',
	methodNotExported: 'Ei ole võimalik kustutada meedet, mida pole eksporditud Jirasse.',
	methodSuccessfulCount: 'Õnnestunud eksportimised',
	methodUpdatedSuccessfulCount: 'Õnnestunud eksporditud meetme uuendamised',
	methodFailedCount: 'Ebaõnnestunud eksportimised',
	methodUpdatedFailedCount: 'Ebaõnnestunud eksporditud meetme uuendamised',
	failedMethods: 'Ebaõnnestunud meetmed',
	chosenCheckboxesWillBeCleared:
		'Valitud märkeruudud tühjendatakse kui valida OK. Seejärel saate märkida kuni 50 meedet Jira E-ITS projekti eksportimiseks.',
	confirmDomainConfigDelete: 'Kas olete kindel, et soovite kustutada seda domeeni konfiguratsiooni?',
	fieldNames: {
		duedate: 'Tähtaeg',
		assignee: 'Vastutaja',
		reporter: 'Teavitaja',
	},
	permissionMissingDelete: 'Ülesannete kustutamiseks puudub õigus!',
	permissionMissingExport: 'Ülesannete eksportimiseks puudub õigus!',
	automaticImport: 'Automaatne importimine',
	automaticInfoText:
		'Kui automaatne importimine on sees, siis meetmete lehele minnes uuendatakse koheselt vastavad meetmed, kui Jira piletitel on tehtud muudatusi. Kui valik on väljas, siis importimiseks peab vajutama "Import" nuppu.',
}
